import React from 'react';
import PropTypes from 'prop-types';
import LoadingBar from 'react-redux-loading-bar';
import Styles from './Header.module.scss';

const Header = ({ left = <></>, right, submenu }) => {
  return (
    <header className={Styles.header}>
      <LoadingBar className={Styles.loadingBar} />
      <div className={Styles.main}>
        <div>{left}</div>
        {right && <div>{right}</div>}
      </div>
      <div className={Styles.secondary}>{submenu}</div>
    </header>
  );
};

Header.propTypes = {
  left: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  right: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  submenu: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.bool])
};

export default Header;
